import {
  MERCHANT_EXPERIENCE_CLEAR, MERCHANT_EXPERIENCE_FROM_SMARTY_GET_SUCCESS,
  MERCHANT_EXPERIENCE_PAGE_VIEW, MERCHANT_EXPERIENCE_BONUS_VIEW,
  MERCHANT_EXPERIENCE_SUSPENDED_MERCHANT_VIEW,
} from './types';

export const clearMerchantExperienceState = () => ({
  type: MERCHANT_EXPERIENCE_CLEAR,
});

export const getMerchantExperienceResponseFromPage = () => ({
  type: MERCHANT_EXPERIENCE_FROM_SMARTY_GET_SUCCESS,
});

export const sendAnalyticsPageViewAction = merchants => ({
  type: MERCHANT_EXPERIENCE_PAGE_VIEW,
  merchants,
});

export const sendAnalyticsBonusViewAction = bonusInfo => ({
  type: MERCHANT_EXPERIENCE_BONUS_VIEW,
  bonusInfo,
});

export const triggerSuspendedMerchantIsViewed = merchant => ({
  type: MERCHANT_EXPERIENCE_SUSPENDED_MERCHANT_VIEW,
  merchant,
});
